// @flow

import { type PaymentSpec } from '@tectonics/prs/payment-spec';
import { type Feature } from '@tectonics/prs/feature';

export function getAllFeatures(spec: PaymentSpec): ImmutableArray<Feature> {
  return [
    ...spec.features,
    ...allPaymentMethodsFeatures(spec),
  ];
}

function allPaymentMethodsFeatures(spec: PaymentSpec): ImmutableArray<Feature> {
  return spec.paymentMethods.reduce((output, paymentMethod) => [...output, ...paymentMethod.features], []);
}
